import React from 'react'
import moment from 'moment'

export const DateDisplay = (time) => moment.unix(time / 1000000000).format('Do MMM YYYY')

export const DateTimeDisplay = (time) => moment.unix(time / 1000000000).format('YYYY-MM-DD hh:mm:ss A')

export const TimeDisplay = (time) => moment.unix(time / 1000000000).format('hh:mm:ss A')

export const formatCashString = (v) => {
    const vA = Math.abs(v)
    if (!Number.isFinite(vA) || Number.isNaN(vA)) return '$0'
    const noDeciStr = !String(vA).includes('.') ? String(vA) : String(vA).slice(0, String(vA).lastIndexOf('.'))
    const numberCommas = () => {
        const chunkString = (str, length) => str.match(new RegExp('.{1,' + length + '}', 'g'))
        const reversed = noDeciStr.split('').reverse().join('')
        return String(chunkString(reversed, 3)).split('').reverse().join('')
    }
    const decimals = () => (!String(vA).includes('.') ? '' : String(vA).slice(String(vA).lastIndexOf('.')))
    return v >= 0 ? '$' + numberCommas() + decimals() : '-$' + numberCommas() + decimals()
}

export const formatCountString = (v) => {
    const vA = Math.abs(v)
    if (!Number.isFinite(vA) || Number.isNaN(vA)) return '0'
    const noDeciStr = !String(vA).includes('.') ? String(vA) : String(vA).slice(0, String(vA).lastIndexOf('.'))
    const numberCommas = () => {
        const chunkString = (str, length) => str.match(new RegExp('.{1,' + length + '}', 'g'))
        const reversed = noDeciStr.split('').reverse().join('')
        return String(chunkString(reversed, 3)).split('').reverse().join('')
    }
    const decimals = () => (!String(vA).includes('.') ? '' : String(vA).slice(String(vA).lastIndexOf('.')))
    return v >= 0 ? '' + numberCommas() + decimals() : '-' + numberCommas() + decimals()
}

export const formatPercentString = (v) => {
    const vA = (Math.round(v * 100) / 100) * 100
    if (!Number.isFinite(vA) || Number.isNaN(vA)) return '0.00%'
    return vA.toFixed(0) + '%'
}

export const formatPresicePercentString = (v) => {
    const vA = ((v * 100) / 100) * 100
    if (!Number.isFinite(vA) || Number.isNaN(vA)) return '0.00%'
    return vA.toFixed(2) + '%'
}

export const formatPercentNumber = (v) => {
    const vA = (Math.round(v * 100) / 100) * 100
    if (!Number.isFinite(vA) || Number.isNaN(vA)) return 0
    return vA
}

export const formatPresicePercentNumber = (v) => {
    const vA = ((v * 100) / 100) * 100
    if (!Number.isFinite(vA) || Number.isNaN(vA)) return 0
    return vA.toFixed(2)
}

export const formatNumber = (v) => {
    const vA = Math.round(v * 100) / 100
    if (!Number.isFinite(vA) || Number.isNaN(vA)) return 0
    return vA
}

export const baccaratStandardBetTypes = ['banker', 'player', 'tie', 'bankerPair', 'playerPair']
export const baccaratLucky6BetTypes = ['banker', 'player', 'tie', 'bankerPair', 'playerPair', 'lucky6']
export const baccaratLucky6SlotBetTypes = ['banker', 'player', 'tie', 'bankerPair', 'playerPair', 'lucky6', 'bonus']
export const baccaratMega6BetTypes = ['banker', 'player', 'tie', 'bankerPair', 'playerPair', 'mega6']
export const baccaratTigerBetTypes = [
    'banker',
    'player',
    'tie',
    'tigerTie',
    'tigerPair',
    'tigerBig',
    'tigerSmall',
    'tiger',
]
export const blackjackStandardBetTypes = ['base', 'doubleDown', 'insurance', 'pair', 'split']
export const blackjackAnyPairSlotBetTypes = ['base', 'pair', 'anyPair', 'split', 'doubleDown', 'insurance', 'bonus']

export const baccaratStandardBetTypesRow = ['banker', 'player', 'tie', 'bankerPair', 'playerPair', 'total']
export const baccaratLucky6BetTypesRow = ['banker', 'player', 'tie', 'bankerPair', 'playerPair', 'lucky6', 'total']
export const baccaratLucky6SlotBetTypesRow = ['banker', 'player', 'tie', 'bankerPair', 'playerPair', 'lucky6', 'bonus', 'total']
export const baccaratMega6BetTypesRow = ['banker', 'player', 'tie', 'bankerPair', 'playerPair', 'mega6', 'total']
export const baccaratTigerBetTypesRow = [
    'banker',
    'player',
    'tie',
    'tigerTie',
    'tigerPair',
    'tigerBig',
    'tigerSmall',
    'tiger',
    'total',
]
export const blackjackStandardBetTypesRow = ['base', 'doubleDown', 'insurance', 'pair', 'split', 'total']
export const blackjackAnyPairSlotBetTypesRow = [
    'base',
    'pair',
    'anyPair',
    'split',
    'doubleDown',
    'insurance',
    'bonus',
    'total',
]

export const baccaratStandardCharPerTypeLabels = ['Banker', 'Player', 'Tie', 'Banker Pair', 'Player Pair']
export const baccaratLucky6CharPerTypeLabels = ['Banker', 'Player', 'Tie', 'Banker Pair', 'Player Pair', 'Lucky6']
export const baccaratLucky6SlotCharPerTypeLabels = ['Banker', 'Player', 'Tie', 'Banker Pair', 'Player Pair', 'Lucky6', 'Bonus']
export const baccaratMega6CharPerTypeLabels = ['Banker', 'Player', 'Tie', 'Banker Pair', 'Player Pair', 'Mega6']
export const baccaratTigerCharPerTypeLabels = [
    'Banker',
    'Player',
    'Tie',
    'Tiger Tie',
    'Tiger Pair',
    'Tiger Big',
    'Tiger Small',
    'Tiger',
]
export const blackjackStandardCharPerTypeLabels = ['Base', 'Double Down', 'Insurance', 'Pair', 'Split']
export const blackjackAnyPairSlotCharPerTypeLabels = [
    'Base',
    'Pair',
    'Any Pair',
    'Split',
    'Double Down',
    'Insurance',
    'Bonus',
]

export const hoursLabels = [
    '12am',
    '1am',
    '2am',
    '3am',
    '4am',
    '5am',
    '6am',
    '7am',
    '8am',
    '9am',
    '10am',
    '11am',
    '12pm',
    '1pm',
    '2pm',
    '3pm',
    '4pm',
    '5pm',
    '6pm',
    '7pm',
    '8pm',
    '9pm',
    '10pm',
    '11pm',
]

export const chartBackgroundColors = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
    'rgba(255, 255, 255, 1)',
    'rgba(71, 161, 155, 0.7)',
    'rgba(230, 253, 121, 0.4)',
]

export const allChartBackgroundColors = ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 255, 255, 1)']

export const seatsBackgroundColors = [
    'rgba(83, 0, 131, 1)',
    'rgba(141, 115, 183, 1)',
    'rgba(206,201,214, 1)',
    'rgba(226,219,233, 1)',
    'rgba(188,174,204, 1)',
    'rgba(255, 159, 64, 1)',
    'rgba(255, 255, 255, 1)',
]

export const gradient5Colors = [
    'rgb(231, 203, 238)',
    'rgb(196, 155, 207)',
    'rgb(161, 109, 177)',
    'rgb(125, 64, 148)',
    'rgb(182, 34, 237)',
]

export const getBetTypeColor = (value) => {
    switch (value) {
        case 'Banker':
            return chartBackgroundColors[0]
        case 'Player':
            return chartBackgroundColors[1]
        case 'Tie':
            return chartBackgroundColors[2]
        case 'Banker Pair':
            return chartBackgroundColors[3]
        case 'Player Pair':
            return chartBackgroundColors[4]
        case 'Lucky 6':
            return chartBackgroundColors[5]
        case 'Mega 6':
            return chartBackgroundColors[7]
        case 'Tiger Tie':
            return chartBackgroundColors[3]
        case 'Tiger Pair':
            return chartBackgroundColors[4]
        case 'Tiger Big':
            return chartBackgroundColors[5]
        case 'Tiger Small':
            return chartBackgroundColors[7]
        case 'Tiger':
            return chartBackgroundColors[8]
        case 'Base':
            return chartBackgroundColors[0]
        case 'Double Down':
            return chartBackgroundColors[1]
        case 'Insurance':
            return chartBackgroundColors[2]
        case 'Pair':
            return chartBackgroundColors[3]
        case 'Split':
            return chartBackgroundColors[4]
        default:
            return chartBackgroundColors[6]
    }
}

export const cashValueStyle = (v) => ({
    color: v > 0 ? 'chartreuse' : v === 0 || isNaN(v) ? 'white' : 'red',
})

export const NanoToHours = (total) => total / 1000000000 / 60 / 60

export const formatDuration = (input) => {
    // units is a string with possible values of y, M, w, d, h, m, s, ms
    var duration = moment()
        .startOf('day')
        .add(input / 1000000000, 's'),
        format = ''

    if (duration.hour() > 0) {
        format += 'H [h] '
    }

    if (duration.minute() > 0) {
        format += 'm [m] '
    }

    format += ' s [s]'

    return duration.format(format)
}

const styles = {
    cardBodyBreakdown: {
        padding: '1em',
        justifyContent: 'center',
        flex: '1 1',
    },
    cardBodySubText: {
        fontSize: '1.1em',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
    },
    divider: {
        position: 'absolute',
        backgroundColor: '#f0f0f0',
        height: 1,
        width: '-webkit-fill-available',
        margin: '1px 34px',
        left: '16px',
    },
    cardBodySubTextLabelTop5_0: { padding: '0 0.5em', color: gradient5Colors[0] },
    cardBodySubTextLabelTop5_1: { padding: '0 0.5em', color: gradient5Colors[1] },
    cardBodySubTextLabelTop5_2: { padding: '0 0.5em', color: gradient5Colors[2] },
    cardBodySubTextLabelTop5_3: { padding: '0 0.5em', color: gradient5Colors[3] },
    cardBodySubTextLabelTop5_4: { padding: '0 0.5em', color: gradient5Colors[4] },
    cardBodySubTextLabelBanker: { padding: '0 0.5em', color: chartBackgroundColors[0] },
    cardBodySubTextLabelPlayer: { padding: '0 0.5em', color: chartBackgroundColors[1] },
    cardBodySubTextLabelTie: { padding: '0 0.5em', color: chartBackgroundColors[2] },
    cardBodySubTextLabelBankerPair: { padding: '0 0.5em', color: chartBackgroundColors[3] },
    cardBodySubTextLabelPlayerPair: { padding: '0 0.5em', color: chartBackgroundColors[4] },
    cardBodySubTextLabelLucky6: { padding: '0 0.5em', color: chartBackgroundColors[5] },
    cardBodySubTextLabelBonus: { padding: '0 0.5em', color: chartBackgroundColors[6] },
    cardBodySubTextLabelMega6: { padding: '0 0.5em', color: chartBackgroundColors[7] },
    cardBodySubTextLabelTigerTie: { padding: '0 0.5em', color: chartBackgroundColors[3] },
    cardBodySubTextLabelTigerPair: { padding: '0 0.5em', color: chartBackgroundColors[4] },
    cardBodySubTextLabelTigerBig: { padding: '0 0.5em', color: chartBackgroundColors[5] },
    cardBodySubTextLabelTigerSmall: { padding: '0 0.5em', color: chartBackgroundColors[7] },
    cardBodySubTextLabelTiger: { padding: '0 0.5em', color: chartBackgroundColors[8] },
    cardBodySubTextLabelBase: { padding: '0 0.5em', color: chartBackgroundColors[0] },
    cardBodySubTextLabelDoubleDown: { padding: '0 0.5em', color: chartBackgroundColors[1] },
    cardBodySubTextLabelInsurance: { padding: '0 0.5em', color: chartBackgroundColors[2] },
    cardBodySubTextLabelPair: { padding: '0 0.5em', color: chartBackgroundColors[3] },
    cardBodySubTextLabelSplit: { padding: '0 0.5em', color: chartBackgroundColors[4] },
    cardBodySubTextLabelTotal: { padding: '1em 1em', color: chartBackgroundColors[6], fontWeight: 'bold' },
    cardBodySubTextValueTotal: { padding: '1em 0', fontWeight: 'bold' },
    cardBodySubTextValue: {},
    cashValue: (v) => ({
        color: v > 0 ? 'chartreuse' : v === 0 || isNaN(v) ? 'white' : 'red',
    }),
}

export const DisplayBlackjackStandardBetTypeSimpleCashBreakdown = ({
    type,
    base,
    doubleDown,
    insurance,
    pair,
    split,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBase}>Base:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(base) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(base)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelDoubleDown}>Double Down:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(doubleDown) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(doubleDown)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelInsurance}>Insurance:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(insurance) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(insurance)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPair}>Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(pair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(pair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelSplit}>Split:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(split) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(split)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValueTotal, ...styles.cashValue(total) }
                            : styles.cardBodySubTextValueTotal
                    }
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBlackjackAnyPairSlotBetTypeSimpleCashBreakdown = ({
    type,
    base,
    pair,
    anyPair,
    split,
    doubleDown,
    insurance,
    bonus,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBase}>Base:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(base) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(base)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPair}>Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(pair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(pair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Any Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(anyPair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(anyPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelSplit}>Split:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(split) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(split)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelDoubleDown}>Double Down:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(doubleDown) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(doubleDown)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelInsurance}>Insurance:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(insurance) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(insurance)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Bonus:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(bonus) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(bonus)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValueTotal, ...styles.cashValue(total) }
                            : styles.cardBodySubTextValueTotal
                    }
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBaccaratStandardBetTypeSimpleCashBreakdown = ({
    type,
    banker,
    player,
    tie,
    bankerPair,
    playerPair,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(banker) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(banker)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(player) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(player)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(tie) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(tie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Banker Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(bankerPair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(bankerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Player Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(playerPair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(playerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValueTotal, ...styles.cashValue(total) }
                            : styles.cardBodySubTextValueTotal
                    }
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBaccaratLucky6SlotBetTypeSimpleCashBreakdown = ({
    type,
    banker,
    player,
    tie,
    bankerPair,
    playerPair,
    lucky6,
    bonus,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(banker) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(banker)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(player) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(player)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(tie) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(tie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Banker Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(bankerPair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(bankerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Player Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(playerPair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(playerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelLucky6}>Lucky6:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(lucky6) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(lucky6)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBonus}>Bonus:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(bonus) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(bonus)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValueTotal, ...styles.cashValue(total) }
                            : styles.cardBodySubTextValueTotal
                    }
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBaccaratLucky6BetTypeSimpleCashBreakdown = ({
    type,
    banker,
    player,
    tie,
    bankerPair,
    playerPair,
    lucky6,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(banker) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(banker)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(player) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(player)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(tie) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(tie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Banker Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(bankerPair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(bankerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Player Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(playerPair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(playerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelLucky6}>Lucky6:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(lucky6) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(lucky6)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValueTotal, ...styles.cashValue(total) }
                            : styles.cardBodySubTextValueTotal
                    }
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBaccaratMega6BetTypeSimpleCashBreakdown = ({
    type,
    banker,
    player,
    tie,
    bankerPair,
    playerPair,
    mega6,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(banker) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(banker)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(player) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(player)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(tie) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(tie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Banker Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(bankerPair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(bankerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Player Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(playerPair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(playerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelMega6}>Mega6:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(mega6) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(mega6)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValueTotal, ...styles.cashValue(total) }
                            : styles.cardBodySubTextValueTotal
                    }
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBaccaratTigerBetTypeSimpleCashBreakdown = ({
    type,
    banker,
    player,
    tie,
    tigerTie,
    tigerPair,
    tigerBig,
    tigerSmall,
    tiger,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(banker) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(banker)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(player) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(player)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(tie) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(tie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTigerTie}>Tiger Tie:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(tigerTie) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(tigerTie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTigerPair}>Tiger Pair:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(tigerPair) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(tigerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTigerBig}>Tiger Big:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(tigerBig) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(tigerBig)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTigerSmall}>Tiger Small:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(tigerSmall) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(tigerSmall)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTiger}>Tiger:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValue, ...styles.cashValue(tiger) }
                            : styles.cardBodySubTextValue
                    }
                >
                    {formatCashString(tiger)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={
                        type === 'playerWinLoss'
                            ? { ...styles.cardBodySubTextValueTotal, ...styles.cashValue(total) }
                            : styles.cardBodySubTextValueTotal
                    }
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBlackjackStandardBetTypeBreakdown = ({
    base,
    doubleDown,
    insurance,
    pair,
    split,
    total,
    perWager,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Base:</span>
                <span style={styles.cardBodySubTextValue}>{base}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Double Down:</span>
                <span style={styles.cardBodySubTextValue}>{doubleDown}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Insurance:</span>
                <span style={styles.cardBodySubTextValue}>{insurance}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Pair:</span>
                <span style={styles.cardBodySubTextValue}>{pair}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Split:</span>
                <span style={styles.cardBodySubTextValue}>{split}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>{perWager ? 'Overall:' : 'Total:'}</span>
                <span style={styles.cardBodySubTextValueTotal}>{total}</span>
            </div>
        </div>
    )
}

export const DisplayBlackjackAnyPairSlotBetTypeBreakdown = ({
    base,
    pair,
    anyPair,
    split,
    doubleDown,
    insurance,
    bonus,
    total,
    perWager,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Base:</span>
                <span style={styles.cardBodySubTextValue}>{base}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Pair:</span>
                <span style={styles.cardBodySubTextValue}>{pair}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Any Pair:</span>
                <span style={styles.cardBodySubTextValue}>{anyPair}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Split:</span>
                <span style={styles.cardBodySubTextValue}>{split}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Double Down:</span>
                <span style={styles.cardBodySubTextValue}>{doubleDown}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Insurance:</span>
                <span style={styles.cardBodySubTextValue}>{insurance}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Bonus:</span>
                <span style={styles.cardBodySubTextValue}>{bonus}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>{perWager ? 'Overall:' : 'Total:'}</span>
                <span style={styles.cardBodySubTextValueTotal}>{total}</span>
            </div>
        </div>
    )
}

export const DisplayBaccaratStandardBetTypeBreakdown = ({
    banker,
    player,
    tie,
    bankerPair,
    playerPair,
    total,
    perWager,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span style={styles.cardBodySubTextValue}>{banker}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span style={styles.cardBodySubTextValue}>{player}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span style={styles.cardBodySubTextValue}>{tie}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Banker Pair:</span>
                <span style={styles.cardBodySubTextValue}>{bankerPair}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Player Pair:</span>
                <span style={styles.cardBodySubTextValue}>{playerPair}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>{perWager ? 'Overall:' : 'Total:'}</span>
                <span style={styles.cardBodySubTextValueTotal}>{total}</span>
            </div>
        </div>
    )
}

export const DisplayBaccaratLucky6BetTypeBreakdown = ({
    banker,
    player,
    tie,
    bankerPair,
    playerPair,
    lucky6,
    total,
    perWager,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span style={styles.cardBodySubTextValue}>{banker}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span style={styles.cardBodySubTextValue}>{player}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span style={styles.cardBodySubTextValue}>{tie}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Banker Pair:</span>
                <span style={styles.cardBodySubTextValue}>{bankerPair}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Player Pair:</span>
                <span style={styles.cardBodySubTextValue}>{playerPair}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelLucky6}>Lucky6:</span>
                <span style={styles.cardBodySubTextValue}>{lucky6}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>{perWager ? 'Overall:' : 'Total:'}</span>
                <span style={styles.cardBodySubTextValueTotal}>{total}</span>
            </div>
        </div>
    )
}

export const DisplayBaccaratMega6BetTypeBreakdown = ({
    banker,
    player,
    tie,
    bankerPair,
    playerPair,
    mega6,
    total,
    perWager,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span style={styles.cardBodySubTextValue}>{banker}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span style={styles.cardBodySubTextValue}>{player}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span style={styles.cardBodySubTextValue}>{tie}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Banker Pair:</span>
                <span style={styles.cardBodySubTextValue}>{bankerPair}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Player Pair:</span>
                <span style={styles.cardBodySubTextValue}>{playerPair}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelLucky6}>Mega6:</span>
                <span style={styles.cardBodySubTextValue}>{mega6}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>{perWager ? 'Overall:' : 'Total:'}</span>
                <span style={styles.cardBodySubTextValueTotal}>{total}</span>
            </div>
        </div>
    )
}

export const DisplayBaccaratTigerBetTypeBreakdown = ({
    banker,
    player,
    tie,
    tigerTie,
    tigerPair,
    tigerBig,
    tigerSmall,
    tiger,
    total,
    perWager,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span style={styles.cardBodySubTextValue}>{banker}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span style={styles.cardBodySubTextValue}>{player}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span style={styles.cardBodySubTextValue}>{tie}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tiger Tie:</span>
                <span style={styles.cardBodySubTextValue}>{tigerTie}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Tiger Pair:</span>
                <span style={styles.cardBodySubTextValue}>{tigerPair}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Tiger Big:</span>
                <span style={styles.cardBodySubTextValue}>{tigerBig}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Tiger Small:</span>
                <span style={styles.cardBodySubTextValue}>{tigerSmall}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelLucky6}>Tiger:</span>
                <span style={styles.cardBodySubTextValue}>{tiger}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>{perWager ? 'Overall:' : 'Total:'}</span>
                <span style={styles.cardBodySubTextValueTotal}>{total}</span>
            </div>
        </div>
    )
}

export const DisplayBetTypeBPBreakdown = ({ banker, player }) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span style={styles.cardBodySubTextValue}>{banker}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span style={styles.cardBodySubTextValue}>{player}</span>
            </div>
        </div>
    )
}

export const DisplayTop5Breakdown = ({ top5 }) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            {top5.map((trend, index) => (
                <div key={index} style={styles.cardBodySubText}>
                    <span style={styles['cardBodySubTextLabelTop5_' + index]}>{trend.label}:</span>
                    <span style={styles.cardBodySubTextValue}>{trend.value}</span>
                </div>
            ))}
        </div>
    )
}

export const DisplayBetTypeBPTBreakdown = ({ banker, player, tie }) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span style={styles.cardBodySubTextValue}>{banker}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span style={styles.cardBodySubTextValue}>{player}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span style={styles.cardBodySubTextValue}>{tie}</span>
            </div>
        </div>
    )
}

export const TrendsVersusBreakdown = ({ data }) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            {data.map((v, i) => {
                return (
                    <div style={styles.cardBodySubText}>
                        <span style={{ color: chartBackgroundColors[i] }}>{v.label}:</span>
                        <span style={styles.cardBodySubTextValue}>{v.percentage}</span>
                    </div>
                )
            })}
        </div>
    )
}

export const PlayersVersusBreakdown = ({ data, labelColors }) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            {data.map((v, i) => {
                return (
                    <div style={styles.cardBodySubText}>
                        <span style={{ color: labelColors[i] }}>{v.label}:</span>
                        <span style={styles.cardBodySubTextValue}>{v.percentage}</span>
                    </div>
                )
            })}
        </div>
    )
}

export const DisplayBlackjackStandardBetTypeCashBreakdown = ({ base, doubleDown, insurance, pair, split, total }) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Base:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(base),
                    }}
                >
                    {formatCashString(base)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Double Down:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(doubleDown),
                    }}
                >
                    {formatCashString(doubleDown)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Insurance:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(insurance),
                    }}
                >
                    {formatCashString(insurance)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Pair:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(pair),
                    }}
                >
                    {formatCashString(pair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Split:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(split),
                    }}
                >
                    {formatCashString(split)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValueTotal,
                        ...cashValueStyle(total),
                    }}
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBlackjackAnyPairSlotBetTypeCashBreakdown = ({
    base,
    pair,
    anyPair,
    split,
    doubleDown,
    insurance,
    bonus,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Base:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(base),
                    }}
                >
                    {formatCashString(base)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Pair:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(pair),
                    }}
                >
                    {formatCashString(pair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Any Pair:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(anyPair),
                    }}
                >
                    {formatCashString(anyPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Split:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(split),
                    }}
                >
                    {formatCashString(split)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Double Down:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(doubleDown),
                    }}
                >
                    {formatCashString(doubleDown)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Insurance:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(insurance),
                    }}
                >
                    {formatCashString(insurance)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Bonus:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(bonus),
                    }}
                >
                    {formatCashString(bonus)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValueTotal,
                        ...cashValueStyle(total),
                    }}
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBaccaratStandardBetTypeCashBreakdown = ({ banker, player, tie, bankerPair, playerPair, total }) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(banker),
                    }}
                >
                    {formatCashString(banker)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(player),
                    }}
                >
                    {formatCashString(player)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(tie),
                    }}
                >
                    {formatCashString(tie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Banker Pair:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(bankerPair),
                    }}
                >
                    {formatCashString(bankerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Player Pair:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(playerPair),
                    }}
                >
                    {formatCashString(playerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValueTotal,
                        ...cashValueStyle(total),
                    }}
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBaccaratLucky6BetTypeCashBreakdown = ({
    banker,
    player,
    tie,
    bankerPair,
    playerPair,
    lucky6,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(banker),
                    }}
                >
                    {formatCashString(banker)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(player),
                    }}
                >
                    {formatCashString(player)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(tie),
                    }}
                >
                    {formatCashString(tie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Banker Pair:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(bankerPair),
                    }}
                >
                    {formatCashString(bankerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Player Pair:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(playerPair),
                    }}
                >
                    {formatCashString(playerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelLucky6}>Lucky6:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(lucky6),
                    }}
                >
                    {formatCashString(lucky6)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValueTotal,
                        ...cashValueStyle(total),
                    }}
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBaccaratMega6BetTypeCashBreakdown = ({
    banker,
    player,
    tie,
    bankerPair,
    playerPair,
    mega6,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(banker),
                    }}
                >
                    {formatCashString(banker)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(player),
                    }}
                >
                    {formatCashString(player)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(tie),
                    }}
                >
                    {formatCashString(tie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Banker Pair:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(bankerPair),
                    }}
                >
                    {formatCashString(bankerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Player Pair:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(playerPair),
                    }}
                >
                    {formatCashString(playerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelLucky6}>Mega6:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(mega6),
                    }}
                >
                    {formatCashString(mega6)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValueTotal,
                        ...cashValueStyle(total),
                    }}
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBaccaratTigerBetTypeCashBreakdown = ({
    banker,
    player,
    tie,
    tigerTie,
    tigerPair,
    tigerBig,
    tigerSmall,
    tiger,
    total,
}) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(banker),
                    }}
                >
                    {formatCashString(banker)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(player),
                    }}
                >
                    {formatCashString(player)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tie:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(tie),
                    }}
                >
                    {formatCashString(tie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelTie}>Tiger Tie:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(tigerTie),
                    }}
                >
                    {formatCashString(tigerTie)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBankerPair}>Tiger Pair:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(tigerPair),
                    }}
                >
                    {formatCashString(tigerPair)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Tiger Big:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(tigerBig),
                    }}
                >
                    {formatCashString(tigerBig)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayerPair}>Tiger Small:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(tigerSmall),
                    }}
                >
                    {formatCashString(tigerSmall)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelLucky6}>Tiger:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValue,
                        ...cashValueStyle(tiger),
                    }}
                >
                    {formatCashString(tiger)}
                </span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span
                    style={{
                        ...styles.cardBodySubTextValueTotal,
                        ...cashValueStyle(total),
                    }}
                >
                    {formatCashString(total)}
                </span>
            </div>
        </div>
    )
}

export const DisplayBetTypeBPTotalBreakdown = ({ banker, player, total }) => {
    return (
        <div style={styles.cardBodyBreakdown}>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelBanker}>Banker:</span>
                <span style={styles.cardBodySubTextValue}>{formatCashString(banker)}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.cardBodySubTextLabelPlayer}>Player:</span>
                <span style={styles.cardBodySubTextValue}>{formatCashString(player)}</span>
            </div>
            <div style={styles.cardBodySubText}>
                <span style={styles.divider}></span>
                <span style={styles.cardBodySubTextLabelTotal}>Total:</span>
                <span style={styles.cardBodySubTextValueTotal}>{formatCashString(total)}</span>
            </div>
        </div>
    )
}

export const allPerLabelFind = (metricIndex) => {
    switch (metricIndex) {
        case 1:
            return 'baccarat'
        case 3:
            return 'blackjack'
        case 5:
            return 'total'
        default:
            return ''
    }
}

export const baccaratStandardPerLabelFind = (metricIndex) => {
    switch (metricIndex) {
        case 1:
            return 'banker'
        case 3:
            return 'player'
        case 5:
            return 'tie'
        case 7:
            return 'banker pair'
        case 9:
            return 'player pair'
        case 11:
            return 'total'
        default:
            return ''
    }
}

export const baccaratLucky6PerLabelFind = (metricIndex) => {
    switch (metricIndex) {
        case 1:
            return 'banker'
        case 3:
            return 'player'
        case 5:
            return 'tie'
        case 7:
            return 'banker pair'
        case 9:
            return 'player pair'
        case 11:
            return 'lucky6'
        case 13:
            return 'total'
        default:
            return ''
    }
}

export const baccaratMega6PerLabelFind = (metricIndex) => {
    switch (metricIndex) {
        case 1:
            return 'banker'
        case 3:
            return 'player'
        case 5:
            return 'tie'
        case 7:
            return 'banker pair'
        case 9:
            return 'player pair'
        case 11:
            return 'mega6'
        case 13:
            return 'total'
        default:
            return ''
    }
}

export const baccaratTigerPerLabelFind = (metricIndex) => {
    switch (metricIndex) {
        case 1:
            return 'banker'
        case 3:
            return 'player'
        case 5:
            return 'tie'
        case 7:
            return 'tiger tie'
        case 9:
            return 'tiger pair'
        case 11:
            return 'tiger big'
        case 13:
            return 'tiger small'
        case 15:
            return 'tiger'
        case 17:
            return 'total'
        default:
            return ''
    }
}

export const blackjackStandardPerLabelFind = (metricIndex) => {
    switch (metricIndex) {
        case 1:
            return 'base'
        case 3:
            return 'double down'
        case 5:
            return 'insurance'
        case 7:
            return 'pair'
        case 9:
            return 'split'
        case 11:
            return 'total'
        default:
            return ''
    }
}

export const blackjackAnyPairSlotPerLabelFind = (metricIndex) => {
    switch (metricIndex) {
        case 1:
            return 'base'
        case 3:
            return 'pair'
        case 5:
            return 'any pair'
        case 7:
            return 'split'
        case 9:
            return 'double down'
        case 11:
            return 'insurance'
        case 13:
            return 'bonus'
        case 15:
            return 'total'
        default:
            return ''
    }
}

export const DEFAULT_EMPTY_USER = `data:image/png;base64,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`

export const findMembership = (memberships, playerID) => {
    if (!memberships) {
        return {
            id: playerID,
            name: playerID,
            picture: DEFAULT_EMPTY_USER,
        }
    }

    if (playerID === '') {
        return {
            id: playerID,
            name: playerID,
            picture: DEFAULT_EMPTY_USER,
        }
    }

    const match = memberships.filter((mb) => mb.id === playerID)
    if (match.length === 0) {
        return {
            id: 'n/a',
            name: 'unknown',
            picture: DEFAULT_EMPTY_USER,
        }
    }

    return match[0]
}
